export default __webpack_public_path__ + "static/media/countries.f9f79dbf.png";